// Utilities
import { makeStyles, tokens } from "@fluentui/react-components";
import { flexParent, flexParentCenterAll } from "@ms/planner-generic-controls/lib/local/utilities/Mixin.styles";
const defaultButtonMinWidth = "170px";
const defaultImageWidth = "192px";
const root = {
    ...flexParent("row"),
    ...flexParentCenterAll,
    height: "100%",
    width: "100%"
};
const elementContainer = {
    ...flexParent("column"),
    ...flexParentCenterAll,
    padding: "10px",
    maxWidth: "500px",
    "> *": {
        textAlign: "center"
    }
};
const errorImage = {
    paddingBottom: "8px",
    "> img": {
        height: defaultImageWidth,
        width: defaultImageWidth
    }
};
const errorText = {
    fontSize: tokens.fontSizeBase400,
    paddingBottom: "8px",
    fontWeight: tokens.fontWeightSemibold
};
const errorSubText = {
    fontSize: tokens.fontSizeBase300,
    paddingBottom: "24px"
};
const buttonContainer = {
    ...flexParent("column"),
    ...flexParentCenterAll,
    paddingBottom: "16px"
};
const primaryButton = {
    marginBottom: "8px",
    "> button": {
        minWidth: defaultButtonMinWidth,
        width: "max-content",
        borderRadius: tokens.borderRadiusXLarge
    }
};
const secondaryButton = {
    "> button": {
        minWidth: defaultButtonMinWidth,
        width: "max-content",
        borderRadius: tokens.borderRadiusXLarge
    }
};
const errorLinkSection = {
    paddingBottom: "24px",
    fontSize: tokens.fontSizeBase200
};
/*
 * Hook to get the styles for the ErrorView component.
 */ export const useErrorViewStyles = makeStyles({
    root,
    elementContainer,
    errorImage,
    errorText,
    errorSubText,
    buttonContainer,
    primaryButton,
    secondaryButton,
    errorLinkSection
});
